import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import {  isEmpty, map, size } from "lodash";
import { connect } from "react-redux"
import BreadcrumbClient from "../../components/Common/BreadcrumbClient"
import { withTranslation } from "react-i18next"
//import Lead from "./Lead";
import ClientLink from "./client-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import CurrencyFormat from 'react-currency-format';
import CurrencyInput from 'react-currency-input-field';
import { getClientDetail, addClientSellerListing, getClientSellerListing, updateClientSellerListing, deleteClientSellerListing } from "../../store/clients/actions"
import ClientSidebar from "components/VerticalLayout/ClientSidebar";
import AgentCurrency from "components/dropdowns/Other/getCurrency";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import SaveButton from "components/buttons/save";
import UpdateButton from "components/buttons/updateBtn";
import RsLink from "components/buttons/rsLink";
import ClientSellerBreadcrumbsClient from "components/Common/ClientSellerBreadcrumbClient";
import ClientSellerBreadcrumbs from "components/Common/ClientSellerBreadcrumbClient";
import ClientSellerMenu from "./menu/client-seller-menu";
import NoAccess from "components/NoAccess";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import moment from "moment";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import ClientEngagementListSeller from "components/dropdowns/Lead/EngagementListSeller";
import EngagementListSellerClient from "components/dropdowns/Lead/EngagementListSellerClient";
import SafeField from "helpers/SafeField";
class ClientSale extends Component {
  constructor(props) {
    super(props)
    this.state = {
      listing:"",
      expandedRow:null
    }
    this.handleClientSellerListingSubmit = this.handleClientSellerListingSubmit.bind(this)
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
  }
     handlePlaceSelected = (address, setFieldValue) => {
      geocodeByAddress(address)
        .then(results => {
          const place = results[0];
          const addressComponents = place.address_components;
  
          const getComponent = (types) => {
            const component = addressComponents.find((component) =>
              types.every((type) => component.types.includes(type))
            );
            return component ? component.long_name : '';
          };
          const latitude = place.geometry.location.lat();
          const longitude = place.geometry.location.lng();
          setFieldValue(`listingAddress`, place.formatted_address);
          setFieldValue(`listingCity`, getComponent(['locality', 'political']));
  
          //setFieldValue('longitude', longitude);
          //setFieldValue('latitude', latitude);
        })
        .catch(error => console.error('Error', error));
    };

      handleEditPlaceSelected = (address, setFieldValue) => {
      geocodeByAddress(address)
        .then(results => {
          const place = results[0];
          const addressComponents = place.address_components;
  
          const getComponent = (types) => {
            const component = addressComponents.find((component) =>
              types.every((type) => component.types.includes(type))
            );
            return component ? component.long_name : '';
          };
          const latitude = place.geometry.location.lat();
          const longitude = place.geometry.location.lng();
          setFieldValue(`listingAddress`, place.formatted_address);
          setFieldValue(`listingCity`, getComponent(['locality', 'political']));
  
          //setFieldValue('longitude', longitude);
          //setFieldValue('latitude', latitude);
        })
        .catch(error => console.error('Error', error));
    };
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (listing) => {
    this.setState({ listing: listing });
    this.setState({ deleteModal: true });
  };

  handleDeleteListing = () => {
    const { onDeleteListing } = this.props;
    const { listing } = this.state;
    //
    if (listing.id !== undefined) {
      onDeleteListing(listing);
      this.setState({ deleteModal: false });
    }
  };
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
  handleClientSellerListingSubmit= (values, actions) => {
    this.props.addClientSellerListing(values, (status)=>{
        if(status==true){
             actions.resetForm();
          }
    });
  }
  componentDidMount() {
    const { match: { params }, onGetClientDetail, onGetClientSellerListing } = this.props;
    onGetClientDetail(params.clientId);
    onGetClientSellerListing(params.id);
    
    
}
componentDidUpdate(prevProps, prevState, snapshot) {
  const { listings } = this.props;
  if (!isEmpty(listings) && size(prevProps.listings) !== size(listings)) {
    this.setState({ listings: {}, isEdit: false });
  }
}
toggleRightCanvas() {
  this.setState({ listing: "", isEdit: false, isRight: !this.state.isRight });
  this.toggle();
}
toggleRightCanvas = arg => {
  const listing = arg;
  this.setState({
    listing: {
      id:listing.id,
      clientListingId: listing.clientListingId,
      clientId:listing.clientId,
      agentId: listing.agentId,
      mlsId: listing.mlsId,
      mlsurl: listing.mlsurl,
      engagementId: listing.engagementId,
      listingAddressId: listing.listingAddressId,
      listingDate: listing.listingDate,
      salePrice: listing.salePrice,
      commissionEarned: listing.commissionEarned,
      expectedSalePrice: listing.expectedSalePrice,
      expectedSaleDays: listing.expectedSaleDays,
      listingStatusId: listing.listingStatusId,
      isExclusive: listing.isExclusive,
      listingClosingDate: listing.listingClosingDate,
      soldDate: listing.soldDate,
      listingTypeId:listing.listingTypeId,
      listingAddressId: listing.listingAddressId,
      listingAddress: listing.listingAddress,
      listingCity: listing.listingCity,
      listingDetails:listing.listingDetails,
      isActive:listing.isActive
    },
    isEdit: true,
  });
  this.toggle();
};
toggleExpand = (index) => {
    this.setState({ expandedRow: this.state.expandedRow === index ? null : index });
  };
  render() {
    const { listings, clietDetail , onUpdateClientSellerListing, loading, userdetail, isResponsive} = this.props;
   
    const { isEdit, deleteModal, expandedRow } = this.state;
    const listing = this.state.listing;
    const hasSellerType = clietDetail.clientTypes && clietDetail.clientTypes.some((type) => type.clientTypeCode === 2);
    //const agentCurrency = <AgentCurrency />;
    //
    return (
      <React.Fragment>
         {this.props.loading && this.props.loading ? (
         <div className="loading">Loading&#8230;</div>
         ) : null}
          <ToastContainer autoClose={2000} />
         <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteListing}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
      
      <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
          {hasSellerType ? (
            <Row>
              <Col sm='2' className="pe-0">
                <ClientSidebar id={this.props.match.params.id} clientId={this.props.match.params.clientId} clientDetail={clietDetail} isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="">
              <Row className="project-header">
                <Col sm="7">
             <ClientSellerBreadcrumbs
              title={this.props.t("Clients")}
              breadcrumbItem={this.props.t(" Property Info")}
            />
            </Col>
            <Col sm="4" className="">
                <h2 className="">{this.props.t( clietDetail.firstName + " " + clietDetail.lastName)}</h2>
                </Col>
            </Row>
            <ClientSellerMenu isResponsive={isResponsive} />
            <Row>
              {/* <Col xl="3">
              <ClientLink id={this.props.match.params.id} clientId={this.props.match.params.clientId} />
              </Col> */}
              
              <Col xl="12">
              <Formik
                  enableReinitialize={true}
                  initialValues={{
                    mlsId: (this.state && this.state.mlsId) || "",
                    mlsURL:(this.state && this.state.mlsURL) || "",
                    salePrice: "",
                    
                    engagementId: '',
                    listingStatusId:1,
                    listingDate: null,
                    agentId: localStorage.getItem('userId'),
                    clientId: this.props.match.params.id,
                    listingAddress:'',
                    isExclusive:""
                  }}
                  validationSchema={Yup.object().shape({
                    mlsId: Yup.string().required("This is Required"),
                      mlsurl: Yup.string()
                      .notRequired() // optional field
                      .url("Please enter a valid URL"),
                    engagementId:Yup.string().required("This is Required"),
                    salePrice: Yup.number()
                    .typeError("Invalid Price")
                    .positive("Price must be greater than 0")
                    .required("This is Required"),
                    listingAddress: Yup.string().required("This is Required"),
                  })}

                  onSubmit={this.handleClientSellerListingSubmit}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
              <Card className="border-full"> 
                    <CardBody>
                    <div className="mt-0 card-title pheading">Add Property</div>
              
                   <Row>
                      <Col sm="3">
                            <EngagementListSellerClient name="engagementId" clientId={this.props.match.params.id} agentId={localStorage.getItem('userId')} typeId={2}  statusId={0} />
                           </Col>   
                   <Col sm="2">
                        <FormGroup className="mb-3">
                            <Label htmlFor="listingDate">
                              {this.props.t("Date of listing")}
                            </Label>
                             <InputGroup>
                             <Flatpickr
                                className={
                                  "form-control" +
                                  (errors.listingDate && touched.listingDate
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                               
                                onChange={(value) => setFieldValue('listingDate', value[0])}
                                options={{
                                  altInput: true,
                                  //minDate: "today",
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d",
                                  //defaultDate:'today'
                                }}
                              />
                        </InputGroup>
                          </FormGroup>
                        </Col>
                        <Col sm="2">
                        <FormGroup className="mb-3">
                            <Label htmlFor="mlsId">
                              {this.props.t("ID (MLS#, any custom number) *")}
                            </Label>
                            <SafeField
                              name="mlsId"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.mlsId && touched.mlsId
                                  ? " is-invalid"
                                  : "")
                              }
                              id="mlsId"
                            />
                             <ErrorMessage
                              name="mlsId"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                         
                        <Col sm="5">
                        <FormGroup className="mb-3">
                            <Label htmlFor="mlsURL">
                              {this.props.t("Public Link")}
                            </Label>
                            <SafeField
                              name="mlsURL"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.mlsURL && touched.mlsURL
                                  ? " is-invalid"
                                  : "")
                              }
                              id="mlsId"
                            />
                             <ErrorMessage
                              name="mlsURL"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
					
                        <Col sm="2">
                        <FormGroup className="mb-3">
                            <Label htmlFor="salePrice">
                            Listed Price *
                            </Label>
                             <SafeField name="salePrice">
                            {({ field, form }) => (
                              <div>
                                <CurrencyInput
                                  id={field.name}
                                  name={field.name}
                                  className={`form-control${
                                    form.errors.salePrice &&
                                    form.touched.salePrice
                                      ? " is-invalid"
                                      : ""
                                  }`}
                                  prefix={userdetail?.agentDefaultCurrencyCode + " " || "$"}
                                  value={field.value || ""}
                                  decimalsLimit={2}
                                  onValueChange={(val) => {
                                    form.setFieldValue(field.name, val);
                                  }}
                                  onBlur={() => form.setFieldTouched(field.name, true)} 
                                />
                                <ErrorMessage
                                  name="salePrice"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            )}
                          </SafeField>
                            {/* <CurrencyInput
                              id="salePrice"
                              name="salePrice"
                              placeholder=""
                              className="form-control"
                              prefix={userdetail?.agentDefaultCurrencyCode + " " }
                              value={values.salePrice}
                              decimalsLimit={2}
                              onValueChange={(value) => {
                                setFieldValue("salePrice", value);
                              }}
                            /> */}
                      
                             <ErrorMessage
                              name="salePrice"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        {/* <Col sm="2">
                        <FormGroup className="mb-3">
                            <Label htmlFor="minBedRoom">
                              {this.props.t("Commission earned (%) ")}
                            </Label>
                            <SafeField
                              name="commissionEarned"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.commissionEarned && touched.commissionEarned
                                  ? " is-invalid"
                                  : "")
                              }
                              id="mlsId"
                            />
                             <ErrorMessage
                              name="commissionEarned"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col> */}
                        <Col sm="2">
                        <FormGroup className="mb-3">
                            <Label htmlFor="isExclusive">
                              {this.props.t("Exclusive listing")}
                            </Label>
                            
                            <SafeField as="select" name="isExclusive" className="form-control" onChange={handleChange}>
                                <option value="">Select</option>
                                <option value="1">Yes</option>
                                <option value="2">No</option>
							                  
                              </SafeField>
                          </FormGroup>
                        </Col>

                             <Col sm="8">
                                                                      <FormGroup className="mb-3">
                                                                        <Label htmlFor="address">
                                                                          {this.props.t("Address *")}
                                                                        </Label>
                                                                        <PlacesAutocomplete
                                                                         value={values.listingAddress}
                                                                          onChange={(values) => setFieldValue(`listingAddress`, values)}
                                                                          onSelect={(values) => this.handlePlaceSelected(values, setFieldValue)}
                                                                        >
                                                                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                                            <div>
                                                                               <input
                                                                              {...getInputProps({
                                                                                placeholder: "Enter Address...",
                                                                                className: `form-control ${
                                                                                  errors.listingAddress &&
                                                                                  touched.listingAddress
                                                                                    ? " is-invalid"
                                                                                    : ""
                                                                                }`,
                                                                              })}
                                                                            />
                                                                            
                                                                              <div className="">
                                                                                {loading ? <div>Loading...</div> : null}
                        
                                                                                {suggestions.map((suggestion, i) => {
                                                                                  const className = suggestion.active
                                                                                    ? 'suggestion-item--active'
                                                                                    : 'suggestion-item';
                                                                                  const style = suggestion.active
                                                                                    ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                                                    : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };
                        
                                                                                  return (
                                                                                    <div
                                                                                      key={i}
                                                                                      {...getSuggestionItemProps(suggestion, {
                                                                                        style,
                                                                                      })}
                                                                                    >
                                                                                      {suggestion.description}
                                                                                    </div>
                                                                                  );
                                                                                })}
                                                                              </div>
                                                                            </div>
                                                                          )}
                                                                        </PlacesAutocomplete>
                        
                                                                         { errors.listingAddress &&
                                                                          touched.listingAddress ? (
                                                                            <div className="invalid-feedback d-block">
                                                                              {errors.listingAddress}
                                                                            </div>
                                                                          ) : null}
                        
                                                                      </FormGroup>
                                                                    </Col>
                    </Row>

                   
					
                    <div className="clearfix">
                          <SaveButton btnClass="btn btn-save mt-27">Save</SaveButton>
                         </div>
					
		
					
                    
             
             </CardBody>
                </Card>
                </Form>
                  )}
             </Formik>
			  <Row>
				<Col sm="12">
					 <Card className="border-full mt-4"> 
                    <CardBody>
                    <h5 className="card-title">Current Listings</h5>
					<div className="">
            <table className="table table-striped">
        <thead>
          {isResponsive ? (
            <tr>
              <th>#</th>
              <th>MLS ID</th>
              <th>Price</th>
               <th></th>
              <th></th>
            </tr>
          ) : (
            <tr>
              <th>#</th>
              <th>MLS ID</th>
              <th>Listing Date</th>
              <th>Sale Price</th>
              <th>Address</th>
              <th>Action</th>
            </tr>
          )}
        </thead>
        <tbody>
          {map(listings, (listing, index) => (
            <React.Fragment key={"_list_" + index}>
              <tr
                onClick={() => isResponsive && this.toggleExpand(index)}
                style={{ cursor: isResponsive ? "pointer" : "default" }}
              >
                {isResponsive ? (
                  <>
                    <td>{index + 1}</td>
                    <td>
                      <a target="_blank" rel="noreferrer" href={listing.mlsurl}>
                        {listing.mlsId}
                      </a>
                    </td>
                    <td>
                      <CurrencyFormat
                        value={listing.salePrice || 0}
                        displayType="text"
                        thousandSeparator={true}
                        prefix={userdetail?.agentDefaultCurrencyCode + " " || "$"}
                      />
                    </td>
                    <td> <ActionEdit onClick={() => this.toggleRightCanvas(listing)} /></td>
                    <td style={{ textAlign: "right" }}>
                      {expandedRow === index ? "▲" : "▼"}
                    </td>
                  </>
                ) : (
                  <>
                    <th>{index + 1}</th>
                    <td>
                      <a target="_blank" rel="noreferrer" href={listing.mlsurl}>
                        {listing.mlsId}
                      </a>
                    </td>
                    <td>
                      <Moment format="Do MMMM YYYY">{listing.listingDate}</Moment>
                    </td>
                    <td>
                      <CurrencyFormat
                        value={listing.salePrice || 0}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={userdetail?.agentDefaultCurrencyCode + " " || '$'}
                      />
                    </td>
                    <td>{listing.listingAddress}</td>
                    <td>
                      <ActionEdit onClick={() => this.toggleRightCanvas(listing)} />
                    </td>
                  </>
                )}
              </tr>

              {isResponsive && expandedRow === index && (
                <tr>
                  <td colSpan={5} className="bg-light p-2">
                    <div><strong>Listing Date:</strong> <Moment format="Do MMMM YYYY">{listing.listingDate}</Moment></div>
                    <div><strong>Address:</strong> {listing.listingAddress}</div>
                    <div><strong>Action:</strong> <ActionEdit onClick={() => this.toggleRightCanvas(listing)} /></div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      
						</div>
					</CardBody>
					</Card>
				</Col>
			</Row>
            </Col>
            
            </Row>
            </Col>
            </Row>
            ) : (
              <NoAccess />
             
            )}
          </Container>
        </div>

        <Offcanvas
                      isOpen={this.state.isRight}
                      direction="end"
                      toggle={this.toggleRightCanvas}
                    >
                      <OffcanvasHeader toggle={this.toggleRightCanvas}>
                        Update 
                      </OffcanvasHeader>
                      <OffcanvasBody>
                      <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id:listing.id,
                    clientListingId: listing.clientListingId,
                    clientId:listing.clientId,
                    agentId: listing.agentId,
                    mlsId: listing.mlsId,
                    mlsurl: listing.mlsurl,
                    listingAddressId: listing.listingAddressId,
                    listingDate: listing.listingDate,
                    engagementId: listing.engagementId,
                    salePrice: listing.salePrice,
                    commissionEarned: listing.commissionEarned,
                    expectedSalePrice: listing.expectedSalePrice,
                    expectedSaleDays: listing.expectedSaleDays,
                    listingStatusId: listing.listingStatusId,
                    isExclusive: (listing.isExclusive==true) ? true : false,
                    //listingClosingDate: listing.listingClosingDate,
                    soldDate: listing.soldDate,
                    listingAddressId: listing.listingAddressId,
                    listingAddress: listing.listingAddress,
                    listingCity: listing.listingCity,
                    listingTypeId:listing.listingTypeId,
                    listingDetails:listing.listingDetails,
                    isActive:listing.isActive
                  }}
                  validationSchema={Yup.object().shape({
                    mlsId: Yup.string().required("This is Required"),
                    mlsurl:Yup.string().required("This is Required"),
                   
                  })}

                  onSubmit={values => {
                   
                  
                      const updateListing = {
                        id:values.id,
                        clientListingId: values.clientListingId,
                        clientId:values.clientId,
                        agentId: values.agentId,
                        mlsId: values.mlsId,
                        mlsurl: values.mlsurl,
                        listingAddressId: values.listingAddressId,
                        engagementId: values.engagementId,
                        listingDate: moment(values.listingDate).format('YYYY-MM-DD'),
                        salePrice: (values.salePrice) ? parseFloat(values.salePrice) : 0,
                        commissionEarned: parseFloat(values.commissionEarned),
                        expectedSalePrice: values.expectedSalePrice,
                        expectedSaleDays: values.expectedSaleDays,
                        listingStatusId: parseInt(values.listingStatusId),
                        isExclusive: (values.isExclusive== 'true' ) ? true : false,
                        //listingClosingDate: moment(values.listingClosingDate).format("YYYY-MM-DD") || null,
                        soldDate: values.soldDate,

                        listingTypeId:values.listingTypeId,
                        listingDetails:values.listingDetails,
                        listingAddressId: parseInt(values.listingAddressId),
                        listingAddress: values.listingAddress,
                        listingCity: values.listingCity,  
                        isActive:values.isActive
                      };
                      //
                      onUpdateClientSellerListing(updateListing, (status)=>{
                          if(status==true){
                              this.toggle();
                          }
                      });
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
             
                   <Row>
                   {/* <Col sm="12">
                        <FormGroup className="mb-3">
                            <Label htmlFor="listingClosingDate">
                              {this.props.t("Closing Date")}
                            </Label>
                             <InputGroup>
                             <Flatpickr
                                className={
                                  "form-control" +
                                  (errors.listingClosingDate && touched.listingClosingDate
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                                value={values.listingClosingDate}
                                onChange={(value) => setFieldValue('listingClosingDate', value[0])}
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d",
                                  minDate:'today'
                                }}
                              />
                        </InputGroup>
                          </FormGroup>
                        </Col> */}
                        <Col sm="12">
                        <FormGroup className="mb-3">
                            <Label htmlFor="mlsId">
                              {this.props.t("ID (MLS#, any custom number) *")}
                            </Label>
                            <SafeField
                              name="mlsId"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.mlsId && touched.mlsId
                                  ? " is-invalid"
                                  : "")
                              }
                              id="mlsId"
                            />
                             <ErrorMessage
                              name="mlsId"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                              {/* <Col sm="12">
                              <ClientEngagementListSeller name="engagementId" clientId={this.props.match.params.id} agentId={localStorage.getItem('userId')} typeId={2}  statusId={0} />
                              </Col> */}
                        <Col sm="12">
                        <FormGroup className="mb-3">
                            <Label htmlFor="mlsURL">
                              {this.props.t("Public Link")}
                            </Label>
                            <SafeField
                              name="mlsurl"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.mlsurl && touched.mlsurl
                                  ? " is-invalid"
                                  : "")
                              }
                              id="mlsId"
                            />
                             <ErrorMessage
                              name="mlsurl"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                            <Col sm="12">
                                                                      <FormGroup className="mb-3">
                                                                        <Label htmlFor="address">
                                                                          {this.props.t("Address *")}
                                                                        </Label>
                                                                        <PlacesAutocomplete
                                                                         value={values.listingAddress}
                                                                          onChange={(values) => setFieldValue(`listingAddress`, values)}
                                                                          onSelect={(values) => this.handleEditPlaceSelected(values, setFieldValue)}
                                                                        >
                                                                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                                            <div>
                                                                              <input
                                                                                {...getInputProps({
                                                                                  placeholder: 'Enter Address...',
                                                                                  className: 'form-control',
                        
                                                                                })}
                                                                              />
                                                                              <div className="">
                                                                                {loading ? <div>Loading...</div> : null}
                        
                                                                                {suggestions.map((suggestion, i) => {
                                                                                  const className = suggestion.active
                                                                                    ? 'suggestion-item--active'
                                                                                    : 'suggestion-item';
                                                                                  const style = suggestion.active
                                                                                    ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                                                    : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };
                        
                                                                                  return (
                                                                                    <div
                                                                                      key={i}
                                                                                      {...getSuggestionItemProps(suggestion, {
                                                                                        style,
                                                                                      })}
                                                                                    >
                                                                                      {suggestion.description}
                                                                                    </div>
                                                                                  );
                                                                                })}
                                                                              </div>
                                                                            </div>
                                                                          )}
                                                                        </PlacesAutocomplete>
                        
                                                                        <ErrorMessage
                                                                          name={`listingAddress`}
                                                                          component="div"
                                                                          className="invalid-feedback"
                                                                        />
                        
                                                                      </FormGroup>
                                                                    </Col>   
						<Col sm="12">
                        <FormGroup className="mb-3">
                            <Label htmlFor="listingDate">
                              {this.props.t("Date of listing")}
                            </Label>
                             <InputGroup>
                             <Flatpickr
                                className={
                                  "form-control" +
                                  (errors.listingDate && touched.listingDate
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                                value={values.listingDate}
                                onChange={(value) => setFieldValue('listingDate', value[0])}
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d",
                                  minDate:'today'
                                }}
                              />
                        </InputGroup>
                          </FormGroup>
                        </Col>
                     
                        <Col sm="12">
                        <FormGroup className="mb-3">
                            <Label htmlFor="salePrice">
                            Listed Price *
                            </Label>
                            <CurrencyInput
                              id="salePrice"
                              name="salePrice"
                              placeholder=""
                              className="form-control"
                              defaultValue={values.salePrice}
                              prefix={userdetail?.agentDefaultCurrencyCode + " "}
                              decimalsLimit={2}
                              onValueChange={(value) => {
                                setFieldValue("salePrice", value);
                              }}
                            />
                      
                             <ErrorMessage
                              name="salePrice"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        {/* <Col sm="12">
                        <FormGroup className="mb-3">
                            <Label htmlFor="commissionEarned">
                              {this.props.t("Commission earned (%) ")}
                            </Label>
                            <SafeField
                              name="commissionEarned"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.commissionEarned && touched.commissionEarned
                                  ? " is-invalid"
                                  : "")
                              }
                              id="mlsId"
                            />
                             <ErrorMessage
                              name="commissionEarned"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col> */}
                    </Row>

                    <Row>
                        <Col sm="12">
                        <FormGroup className="mb-3">
                            <Label htmlFor="listingStatusId">
                              {this.props.t("Status")}
                            </Label>
                            <SafeField as="select" name="listingStatusId" className="form-control" onChange={handleChange}>
                                <option value="">Select</option>
                                <option value="1">Available</option>
                                <option value="2">Conditionally Sold</option>
							                  <option value="3">Sold</option>
                              </SafeField>

                         
                          </FormGroup>
                        </Col>
                        <Col sm="12">
                        <FormGroup className="mb-3">
                            <Label htmlFor="isExclusive">
                              {this.props.t("Exclusive listing")}
                            </Label>
                            
                            <SafeField as="select" name="isExclusive" className="form-control" onChange={handleChange}>
                                <option value="">Select</option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>
							                  
                              </SafeField>
                          </FormGroup>
                        </Col>
                          
                        <Col sm="12">
                       
                        <div className="clearfix">
                        <UpdateButton>{this.props.t("Update")}</UpdateButton>{ " " } <RsLink onClick={this.toggleRightCanvas}>Close</RsLink>
                          
                        </div>
                        
                        </Col>

                       
						
						
                        
                    </Row>

                </Form>
                  )}
             </Formik>

                      </OffcanvasBody>
                    </Offcanvas>
      </React.Fragment>
    )
  }
}
ClientSale.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  addClientSellerListing:PropTypes.func,
  onGetClientSellerListing:PropTypes.func,
  listings:PropTypes.array,
  match:PropTypes.object,
  onGetClientDetail:PropTypes.func,
  clietDetail:PropTypes.object,
  onUpdateClientSellerListing:PropTypes.func,
  onDeleteListing: PropTypes.func,
  loading: PropTypes.object,
  userdetail:PropTypes.object,
  isResponsive:PropTypes.object
}
const mapStateToProps = ({ Clients }) => (
  {
    clietDetail:Clients.clietDetail,
    listings: Clients.listings,
    loading: Clients.loading
  })
const mapDispatchToProps = dispatch => (
  {
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
  addClientSellerListing: (data, callback) => dispatch(addClientSellerListing(data, callback)),
  onGetClientSellerListing:(clientId) =>dispatch(getClientSellerListing(clientId)),
  onUpdateClientSellerListing: (data, callback) => dispatch(updateClientSellerListing(data,callback)),
  onDeleteListing: (id) => dispatch(deleteClientSellerListing(id))
 
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ClientSale))
